import React from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import MyrbLogo from 'components/MyrbLogo';

import styles from './MiniFooter.scss';// to import local scss fle

const MiniFooter = () => (
  <div className={cn('row', styles.container)} >
    <div className={cn('col s12', styles.miniFooterInBig)}>
      <div className={cn('col s12 m4', styles.logoContainer)}>
        <MyrbLogo />
      </div>
      <div className={cn('col s12 m8', styles.icons)}>
        <div className={cn('col s12', styles.socialIcons)}>
          <span className={styles.connectWithUs}>Connect with us</span>
          <a href="https://www.facebook.com/MyRecruitboard/" target="blank">
            <img src="https://media.dev.myrecruitboard.com/Images/facebook.png" alt="web_feed" />
          </a>
          <a href="https://twitter.com/myrecruitboard?lang=en" target="blank">
            <img src="https://media.dev.myrecruitboard.com/Images/twitter.png" alt="web_feed" />
          </a>
          <a href="https://www.instagram.com/explore/tags/myrecruitboard/" target="blank">
            <img src="https://media.dev.myrecruitboard.com/Images/instagram.png" alt="web_feed" />
          </a>
          <a href="https://www.snapchat.com/MyRecruitBoard" target="blank">
            <img src="https://media.dev.myrecruitboard.com/Images/snapchat.png" alt="web_feed" />
          </a>
        </div>
        <div className={cn('col s12', styles.copyRight)}>
                  Copyright © 2022. All Rights Reserved
              </div>
      </div>
    </div>
    <div className={cn('col s12 m4', styles.miniFooterInSmall)}>
      <div className={cn('col s12 m8', styles.lineBelowSocialIcons)}>
        <div className={cn('col s12', styles.socialIcons)}>
          <span className={styles.connectWithUs}>Connect with us</span>
          <a href="https://www.facebook.com/MyRecruitboard/" target="blank">
            <img src="https://media.dev.myrecruitboard.com/Images/facebook.png" alt="web_feed" />
          </a>
          <a href="https://twitter.com/myrecruitboard?lang=en" target="blank">
            <img src="https://media.dev.myrecruitboard.com/Images/twitter.png" alt="web_feed" />
          </a>
          <a href="https://www.instagram.com/explore/tags/myrecruitboard/" target="blank">
            <img src="https://media.dev.myrecruitboard.com/Images/instagram.png" alt="web_feed" />
          </a>
          <a href="https://www.snapchat.com/MyRecruitBoard" target="blank">
            <img src="https://media.dev.myrecruitboard.com/Images/snapchat.png" alt="web_feed" />
          </a>
        </div>
      </div>
      <div className={cn('col s12 m4', styles.logoPadding)}>
        <MyrbLogo />
      </div>
      <div className={cn('col s12', styles.copyRight)}>
            Copyright © 2022. All Rights Reserved
        </div>
    </div>
  </div>
);

export default MiniFooter;




// WEBPACK FOOTER //
// ./src/components/MiniFooter/MiniFooter.js